import { render, staticRenderFns } from "./component-e360d18d.vue?vue&type=template&id=55da1042&scoped=true&"
import script from "./component-e360d18d.vue?vue&type=script&lang=js&"
export * from "./component-e360d18d.vue?vue&type=script&lang=js&"
import style0 from "./component-e360d18d.vue?vue&type=style&index=0&id=55da1042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55da1042",
  null
  
)

export default component.exports